function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { CarouselImageArrow, CarouselItem, BasicCarousel } from "../../library/components/carousel";
import EditIcon from "../../library/cms/edit-icon";
import { MediaManagerController } from "../../library/cms/media-manager";
import JsUtility from "../../library/utils/utility";
export default class Carousel extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onEditClick", event => {
      this.mediaController.mode = 'multi-select';
      this.mediaController.show(this.props.files);
    });

    _defineProperty(this, "onNextArrowClick", () => {
      this.basicCarousel.clearInterval();
      this.basicCarousel.slideNext();
    });

    _defineProperty(this, "onPrevArrowClick", () => {
      this.basicCarousel.clearInterval();
      this.basicCarousel.slidePrev();
    });

    _defineProperty(this, "onSlide", index => {//if (this.carouselIndicators) this.carouselIndicators.update(index);
    });
  }

  componentDidMount() {}

  get nodes() {
    var files = this.props.files;
    return files.map(file => {
      var fileUrl = file.url + '?width=1400';
      var mobileFileUrl = JsUtility.toMobileUrl(file.url) + '?width=640';
      var randomId = JsUtility.randomId;
      var alt = file.title;
      return /*#__PURE__*/React.createElement(CarouselItem, {
        video: true,
        key: randomId,
        newTarget: file.newTarget
      }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 641px)",
        srcSet: fileUrl
      }), /*#__PURE__*/React.createElement("source", {
        media: "(max-width: 640px)",
        srcSet: mobileFileUrl
      }), alt ? /*#__PURE__*/React.createElement("img", {
        src: fileUrl,
        alt: alt
      }) : /*#__PURE__*/React.createElement("img", {
        src: fileUrl
      })));
    });
  }

  onFilesCancel() {}

  render() {
    var nodes = this.nodes;
    var cls = 'relative';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement(BasicCarousel, {
      auto: false,
      interval: "3000",
      ref: ref => this.basicCarousel = ref,
      onSlide: this.onSlide
    }, nodes), /*#__PURE__*/React.createElement(EditIcon, {
      onClick: this.onEditClick,
      active: this.props.active,
      cls: this.props.iconCss
    }, /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: "/api/MediaFile",
      data: this.props.mediaManagerData,
      ref: ref => this.mediaController = ref,
      onFilesSelected: this.props.onFilesSelected,
      onCancel: this.onFilesCancel
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CarouselImageArrow, {
      cls: "next",
      onClick: this.onNextArrowClick
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/icons/next-arrow.svg",
      alt: "next"
    })), /*#__PURE__*/React.createElement(CarouselImageArrow, {
      cls: "prev",
      onClick: this.onPrevArrowClick
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/icons/prev-arrow.svg",
      alt: "previous"
    }))));
  }

}